import React, { useState } from "react";
import { SITE, WHATSAPP_LINK, EMAIL_LINK } from "../lib/site-data";
import { Menu, X, MessageCircle } from "lucide-react";

const NAV = [
  { label: "About", href: "/#about" },
  { label: "Programmes", href: "/#programmes" },
  { label: "Schedule", href: "/#schedule" },
  { label: "Reviews", href: "/#testimonials" },
  { label: "Articles", href: "/#articles" },
  { label: "Visit", href: "/#location" },
  { label: "Sign Up", href: "/#signup" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-[#E2E8F0]/60"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <a
            href="#top"
            className="flex items-center gap-3"
            data-testid="brand-link"
          >
            <img
              src={SITE.logoUrl}
              alt="The Tutor's Table logo"
              className="h-12 w-12 rounded-full object-cover ring-1 ring-[#E2E8F0]"
            />
            <div className="leading-tight">
              <div className="font-heading text-lg font-semibold text-[#1E3A8A] tracking-tight">
                The Tutor&apos;s Table
              </div>
              <div className="text-xs text-[#475569] hidden sm:block">
                Primary 3–6 · English & Math
              </div>
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-7 xl:gap-8">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                className="text-sm font-medium text-[#0F172A] hover:text-[#1E3A8A] transition-colors"
                data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {n.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href={WHATSAPP_LINK(
                `Hi ${SITE.name}, I would like to enquire about classes for my child.`
              )}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#1E3A8A] text-white hover:bg-[#1E40AF] px-5 py-2.5 rounded-full text-sm font-medium transition-all shadow-sm hover:shadow-md"
              data-testid="header-whatsapp-cta"
            >
              <MessageCircle className="w-4 h-4" />
              Chat on WhatsApp
            </a>
          </div>

          <button
            className="lg:hidden p-2 rounded-md text-[#0F172A] hover:bg-[#E2E8F0]/40"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {open && (
          <div className="lg:hidden pb-6 pt-2 border-t border-[#E2E8F0]/60" data-testid="mobile-menu">
            <div className="flex flex-col gap-4 pt-4">
              {NAV.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="text-base font-medium text-[#0F172A]"
                  data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {n.label}
                </a>
              ))}
              <a
                href={WHATSAPP_LINK(
                  `Hi ${SITE.name}, I would like to enquire about classes for my child.`
                )}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-[#1E3A8A] text-white px-5 py-3 rounded-full text-sm font-medium mt-2"
                data-testid="mobile-whatsapp-cta"
              >
                <MessageCircle className="w-4 h-4" /> Chat on WhatsApp
              </a>
              <a
                href={EMAIL_LINK(
                  "Enquiry about classes",
                  `Hi ${SITE.name},\n\nI would like to enquire about classes for my child.\n\nThanks.`
                )}
                className="inline-flex items-center justify-center gap-2 border border-[#1E3A8A] text-[#1E3A8A] px-5 py-3 rounded-full text-sm font-medium"
                data-testid="mobile-email-cta"
              >
                Email us
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
